module.exports = __webpack_public_path__ + "static/gallery-12@2x-5fa0e51f1fbbaf2a143e1b1e88bc72d4.jpg";